import { BookingNotificationIcon, CommonHorizontalArrow7Icon } from '@local/assets/icons'

import Clickable from '@web/ui/components/Clickable'

import { Section, SectionContent } from '../Section'
import styles from './BookingNotificationSection.module.scss'

interface UIBookingNotificationSectionProps {
  count: number
  onClick?: () => void
  clickCode?: string
}

export default function UIBookingNotificationSection({ count, onClick, clickCode }: UIBookingNotificationSectionProps) {
  return (
    <Section>
      <SectionContent>
        <Clickable className={styles.booking_notification_area} onClick={onClick} nClickCode={clickCode}>
          <div className={styles.icon_area}>
            <BookingNotificationIcon className={styles.icon} aria-hidden="true" />
          </div>
          <div className={styles.txt_area}>
            <strong className={styles.title}>
              지금 기다리고 있는 빈자리 <span className={styles.count}>{count}</span>
            </strong>
            <div className={styles.txt}>빈자리가 생기면 네이버앱 알림으로 알려드려요.</div>
          </div>
          <CommonHorizontalArrow7Icon className={styles.icon_arrow} aria-hidden="true" />
        </Clickable>
      </SectionContent>
    </Section>
  )
}
